export default __webpack_public_path__ + "static/media/authorbg06.30fb9bb0.jpg";